import script from "./LearnerDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LearnerDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./LearnerDetailPage.vue?vue&type=style&index=0&id=8b112bd4&lang=css"

const __exports__ = script;

export default __exports__